// extracted by mini-css-extract-plugin
export var orderSummary = "_ox-0";
export var showMoreLessButton = "_ox-1";